@if (viewModel.parcels.length > 0) {
  <label [for]="control.element.id" style="color: black; margin-bottom: 0">{{ control.element.label }} </label>
  <div class="form-check">
    <input type="radio"
      [name]="control.element.id"
      [id]="control.element.id + '-enter_manually'"
      [formControl]="control"
      class="form-check-input"
      value="enter_manually">
      <label class="form-check-label"
        style="color: black"
      [for]="control.element.id + '-enter_manually'">Enter address manually</label>
    </div>
    @for (parcel of viewModel.parcels; track parcel) {
      <div>
        <div class="form-check">
          <input type="radio"
            [name]="control.element.id"
            [id]="getControlId(parcel)"
            [formControl]="control"
            class="form-check-input"
            [value]="getControlId(parcel)">
            <label class="form-check-label"
              style="color: black"
            [for]="getControlId(parcel)">{{ getAddressLabel(parcel) }}</label>
          </div>
        </div>
      }
    }
